import * as yup from 'yup'

const schema = ({ accept, mimeTypes }) =>
  yup.object().shape({
    documentType: yup
      .string()
      .oneOf(['attachment', 'linkedDocument'], 'Selecione o tipo de documento')
      .required('Selecione o tipo de documento'),
    attachments: yup.mixed().fileUpload({
      sizeLimit: 30,
      unit: 'MB',
      types: accept,
      mimeTypes,
      required: { field: 'documentType', is: 'attachment' },
    }),
    privacyPolicyIds: yup
      .array()
      .of(
        yup.object().shape({
          id: yup.number(),
          name: yup.string(),
        }),
      )
      .when('documentType', {
        is: 'linkedDocument',
        then: (schema) => schema.min(1, 'Selecione ao menos um documento'),
      }),
  })

export default schema
